module.exports = __webpack_public_path__ + "static/media/logo-utm-boss.c1a150fa.svg";